import axios from 'axios';

// Configuração da API - Tudo via backend
const API_CONFIG = {
  baseUrl: 'https://backendconsultabitrix.villelaintegra.com.br/api/banco-bitrix', // Via backend
  timeout: 10000
};

// Verificar status da API
export const checkApiStatus = async () => {
  try {
    await axios.get(`${API_CONFIG.baseUrl}/json`, { timeout: 5000 });
    return 'online';
  } catch (error) {
    return 'offline';
  }
};

// Extrair ID da parcela (função auxiliar)
const extractParcelaId = (cobrancaId) => {
  if (!cobrancaId) return '';
  
  // Limpar e normalizar o ID
  let cleanId = cobrancaId.toString().trim().toUpperCase();
  
  // Se já tem formato PC-XXXX, manter (mas verificar duplicação)
  if (cleanId.match(/^PC-\d+/)) {
    // Remover duplicação se existir
    cleanId = cleanId.replace(/^PC-PC-/, 'PC-');
    return cleanId;
  }
  
  // Se tem outros caracteres, extrair apenas números e adicionar PC-
  const numbers = cleanId.replace(/\D/g, '');
  if (numbers) {
    return `PC-${numbers}`;
  }
  
  // Se não conseguiu extrair números, retornar como está
  return cleanId;
};

// Busca inteligente híbrida (banco local + API)
export const searchCobrancaHybrid = async (cobrancaId) => {
  const cleanCobrancaId = extractParcelaId(cobrancaId);
  
  console.log(`🔍 Iniciando busca híbrida para: ${cobrancaId}`);

  try {
    // Usar a nova rota de busca híbrida (banco + API)
    const response = await axios.get(`${API_CONFIG.baseUrl}/search-smart/${cleanCobrancaId}`, { 
      timeout: 30000, // Tempo maior pois pode buscar na API externa
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      }
    });
    
    const result = response.data;
    
    console.log('🔍 Resultado da busca híbrida:', result);
    
    if (result.success && result.data && result.data.length > 0) {
      console.log(`✅ Busca híbrida bem-sucedida! Método: ${result.searchMethod}`);
      console.log(`📊 Fonte: ${result.searchSource}`);
      console.log(`📊 Total encontrado: ${result.data.length} cobrança(s)`);
      
      // Retornar TODOS os resultados encontrados
      const allCobrancasData = result.data.map(item => item.data);
      const firstResult = result.data[0];
      
      return {
        success: true,
        data: allCobrancasData, // Retorna array com TODAS as cobranças
        parcela: firstResult.code,
        endpoint: firstResult.endpoint,
        searchMethod: result.searchMethod,
        searchSource: result.searchSource,
        searchSteps: [result.searchMethod],
        testedParcelas: result.matchingCodes || [cleanCobrancaId],
        cobrancaId: cleanCobrancaId,
        totalFound: result.totalFound,
        executionTime: result.executionTime,
        allResults: result.data
      };
    } else {
      console.log(`❌ Busca híbrida não encontrou dados:`, result);
      
      return {
        success: false,
        data: null,
        parcela: null,
        endpoint: '',
        searchMethod: result.searchMethod || 'hybrid_error',
        searchSource: result.searchSource || 'unknown',
        searchSteps: [result.searchMethod || 'hybrid_error'],
        testedParcelas: result.matchingCodes || [],
        cobrancaId: cleanCobrancaId,
        error: result.error,
        message: result.message,
        executionTime: result.executionTime
      };
    }
    
  } catch (error) {
    console.error(`❌ Erro na busca híbrida:`, error.message);
    
    return {
      success: false,
      data: null,
      parcela: null,
      endpoint: '',
      searchMethod: 'hybrid_error',
      searchSource: 'error',
      searchSteps: ['hybrid_error'],
      testedParcelas: [],
      cobrancaId: cleanCobrancaId,
      error: 'Erro na busca híbrida',
      message: error.message
    };
  }
};

// Busca universal (PC, CNPJ ou CPF)
export const searchUniversal = async (searchTerm) => {
  console.log(`🔍 Iniciando busca universal para: ${searchTerm}`);

  try {
    // Usar a nova rota de busca universal
    const response = await axios.get(`${API_CONFIG.baseUrl}/search-universal/${encodeURIComponent(searchTerm)}`, { 
      timeout: 30000,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      }
    });
    
    const result = response.data;
    
    console.log('🔍 Resultado da busca universal:', result);
    
    if (result.success && result.data && result.data.length > 0) {
      console.log(`✅ Busca universal bem-sucedida! Tipo: ${result.searchType}`);
      console.log(`🔍 Método: ${result.searchMethod}`);
      console.log(`📊 Total encontrado: ${result.data.length} cobrança(s)`);
      
      // Retornar TODOS os resultados encontrados
      const allCobrancasData = result.data.map(item => item.data);
      const firstResult = result.data[0];
      
      return {
        success: true,
        data: allCobrancasData, // Retorna array com TODAS as cobranças
        parcela: firstResult.code,
        endpoint: firstResult.endpoint,
        searchMethod: result.searchMethod,
        searchType: result.searchType,
        searchSource: result.searchSource,
        searchSteps: [result.searchMethod],
        testedParcelas: result.matchingCodes || [searchTerm],
        searchTerm: result.searchedTerm || searchTerm,
        totalFound: result.totalFound,
        executionTime: result.executionTime,
        allResults: result.data
      };
    } else {
      console.log(`❌ Busca universal não encontrou dados:`, result);
      
      return {
        success: false,
        data: null,
        parcela: null,
        endpoint: '',
        searchMethod: result.searchMethod || 'universal_error',
        searchType: result.searchType || 'unknown',
        searchSource: result.searchSource || 'unknown',
        searchSteps: [result.searchMethod || 'universal_error'],
        testedParcelas: result.matchingCodes || [],
        searchTerm: result.searchedTerm || searchTerm,
        error: result.error,
        message: result.message,
        executionTime: result.executionTime
      };
    }
    
  } catch (error) {
    console.error(`❌ Erro na busca universal:`, error.message);
    
    return {
      success: false,
      data: null,
      parcela: null,
      endpoint: '',
      searchMethod: 'universal_error',
      searchType: 'error',
      searchSource: 'error',
      searchSteps: ['universal_error'],
      testedParcelas: [],
      searchTerm: searchTerm,
      error: 'Erro na busca universal',
      message: error.message
    };
  }
};

// Buscar cobrança (método legado - mantido para compatibilidade)
export const searchCobranca = async (cobrancaId) => {
  // Usar busca híbrida como padrão
  return await searchCobrancaHybrid(cobrancaId);
};

// Buscar APIs externas (mantida para compatibilidade)
export const searchExternalApis = async (cobrancaId) => {
  const cleanCobrancaId = extractParcelaId(cobrancaId);
  
  try {
    const response = await axios.get(`${API_CONFIG.baseUrl}/external/${cleanCobrancaId}`, {
      timeout: 10000,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });
    
    return {
      success: true,
      data: response.data,
      cobrancaId: cleanCobrancaId
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
      cobrancaId: cleanCobrancaId
    };
  }
};

// Verificar status de todas as APIs
export const checkAllApisStatus = async () => {
  try {
    const response = await axios.get(`${API_CONFIG.baseUrl}/status`, {
      timeout: 10000,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });
    
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};
